module.exports = __webpack_public_path__ + "img/stock7.7e91c067.png";